import * as React from "react"
import type { SVGProps } from "react"
const SvgLiquidCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 20a1 1 0 0 1-.71-.29A1 1 0 0 1 14 19q0-.42.29-.71A1 1 0 0 1 15 18h2q.42 0 .71-.29A1 1 0 0 0 18 17v-2q0-.94.55-1.72t1.45-1.1v-.35a3 3 0 0 1-1.45-1.1A3 3 0 0 1 18 9V7a1 1 0 0 0-.29-.71A1 1 0 0 0 17 6h-2a1 1 0 0 1-.71-.29A1 1 0 0 1 14 5q0-.42.29-.71A1 1 0 0 1 15 4h2q1.24 0 2.13.88c.89.88.87 1.29.87 2.12v2q0 .42.29.71.29.3.71.29c.42-.01.52.1.71.29q.3.29.29.71v2q0 .42-.29.71A1 1 0 0 1 21 14a1 1 0 0 0-.71.29A1 1 0 0 0 20 15v2q0 1.24-.87 2.13A3 3 0 0 1 17 20zm-8 0a3 3 0 0 1-2.12-.87A3 3 0 0 1 4 17v-2a1 1 0 0 0-.29-.71A1 1 0 0 0 3 14a1 1 0 0 1-.71-.29A1 1 0 0 1 2 13v-2q0-.42.29-.71A1 1 0 0 1 3 10q.42 0 .71-.29A1 1 0 0 0 4 9V7q0-1.25.88-2.12A3 3 0 0 1 7 4h2q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 9 6H7a1 1 0 0 0-.71.29A1 1 0 0 0 6 7v2q0 .94-.55 1.73-.55.77-1.45 1.1v.34A3 3 0 0 1 6 15v2q0 .42.29.71.29.3.71.29h2q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 9 20z" />
  </svg>
)
export default SvgLiquidCode
